const analyticsEventsConfig = {
    Home: {
        PushProfile: true,
        Login: false,
        PageView: false,
        Search: true,
        CitySearch: false,
        Checkin: false,
        Checkout: false,
        TotalNights: false,
        Ratings: false,
        Nationality: false,
        CountryOfResidence: false,
        SpecialCategory: false,
        RoomInfo: false,
        IncentiveBanner: false
    },
    Search: {
        PageView: true,
        ModifySearch: false,
        HotelFilter: false,
        LocationFilter: false,
        Ratings: false,
        SelectRoom: false,
        subRegionName: true,
        AddToFavourites: true,
        ViewFavourites: true,
        FreeCancellationAvailable: true,
        hover_reviewLink:true,
        click_reviewLink:true,
        click_Filter:true
    },
    ProductDetail: {
        PageView: false,
        SwitchView: false,
        RateFilter: false,
        MoreOptions: false,
        CancellationPolicy: false,
        RoomFacilities: false,
        MaximumCapacity: false,
        RoomImages: false,
        BookNow: true,
        reviewLink:true,
        user_reviewLink:true,
    },
    PassengerDetail: {
        PageView: false,
        SoldOutPopup: false,
        BackToSearch: false,
        ProceedToReview: false

    },
    PassengerReview: {
        PageView: false,
        Block: true,
        ProceedToPay: true
    },
    Payment: {
        PageView: false,
        PayNow: false,
    },
    SessionExpire: {
        Popup: false,
        SearchAgain: false
    },
    Confirmation: {
        PageView: true
    }
}
export default analyticsEventsConfig;